export const gridResponsiveClassName = 'grid w-full grid-cols-1 gap-6 mt-2 grid-cols-[repeat(auto-fill,minmax(260px,1fr))]';